import { render, staticRenderFns } from "./BaselineCompounds.vue?vue&type=template&id=13f0582c&"
import script from "./BaselineCompounds.vue?vue&type=script&lang=js&"
export * from "./BaselineCompounds.vue?vue&type=script&lang=js&"
import style0 from "./BaselineCompounds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports